import React, { Component, useState } from "react";
import { Redirect } from "react-router";
import styled from "styled-components";

import { playPlaylist } from "./action";
import { Col, Text, Box } from "../../../comps";
import Fab from "@material-ui/core/Fab";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Theme } from "../../../theme/theme-provider";

import { faPlay } from "@fortawesome/free-solid-svg-icons";

const GridItem = styled.div`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  margin: ${({ margin }) => margin};
  display: block;
  box-sizing: border-box;
  transition: opacity 0.3s;
  &:hover {
    /* opacity: 1; */
  }
`;

const CardWrapper = styled(Box)`
  position: relative;
  width: 100%;
  height: 100%;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  overflow: hidden;
  &:hover {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.6);
  }
`;

const CardContent = styled(Col)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  ${CardWrapper}:hover {
  }
`;

const CardOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${({ gradient }) => {
    console.log(gradient);
    return gradient;
  }};
`;

//#36322f 70%,
//#36322f 100%
const Content = styled(Col)`
  width: 100%;
  height: auto;
  margin-top: auto;
  padding-left: 8px;
  padding-right: 8px;
  margin-bottom: 20px;
`;

const ImgWrapper = styled.div`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
`;

const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const PlayButton = styled.div`
  position: absolute;
  bottom: 16px;
  right: 16px;
  opacity: 0;
  ${CardWrapper}:hover & {
    opacity: 1;
  }
`;

export default ({
  width,
  height,
  margin,
  color,
  playlistInfo: {
    id: playlistId,
    name: playlistTitle,
    thumbnail,
    ownerUsername,
  },
}) => {
  const [redirectTo, setRedirect] = useState("");
  const handlePlay = (event) => {
    event.stopPropagation();
    event.cancelBubble = true;
    playPlaylist({ id: playlistId, name: playlistTitle });
  };
  return (
    <GridItem
      className={"item"}
      width={width}
      height={height}
      margin={margin}
      key={playlistId}
      onClick={() => {
        setRedirect(`/playlist/${playlistId}`);
      }}
    >
      <div class="item-content">
        <CardWrapper>
          <ImgWrapper width={width} height={height}>
            <Img src={thumbnail} />
          </ImgWrapper>
          <CardOverlay
            gradient={`linear-gradient(180deg, transparent 0%,${color} 80%, ${color} 100%)`}
          />
          <CardContent>
            {redirectTo && <Redirect push to={redirectTo} />}
            <div />
            <Content>
              <Text color={`#d7e0da`} fontWeight={600} fontSize={"16px"}>
                {playlistTitle}
              </Text>
              <Text
                color={Theme.color.WHITE_1}
                fontWeight={400}
                fontSize={"14px"}
                marginTop={"10px"}
              >{`by ${ownerUsername || "AVC"}`}</Text>
            </Content>
          </CardContent>
          <PlayButton>
            <Fab
              size="small"
              style={{
                backgroundColor: Theme.color.BLUE_5,
              }}
              color="primary"
              aria-label="add"
              onClick={handlePlay}
            >
              <FontAwesomeIcon icon={faPlay} />
            </Fab>
          </PlayButton>
        </CardWrapper>
      </div>
    </GridItem>
  );
};
